import { render, staticRenderFns } from "./linha-de-toggle.vue?vue&type=template&id=49a032d0&"
import script from "./linha-de-toggle.vue?vue&type=script&lang=js&"
export * from "./linha-de-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a032d0')) {
      api.createRecord('49a032d0', component.options)
    } else {
      api.reload('49a032d0', component.options)
    }
    module.hot.accept("./linha-de-toggle.vue?vue&type=template&id=49a032d0&", function () {
      api.rerender('49a032d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/linha-de-toggle/linha-de-toggle.vue"
export default component.exports